/**
 * The Carrier Bridge product name as the UI shows it, shared by the customer
 * views and the Admin Center.
 *
 * The commercial name is not final yet (CarrierBridge™ vs Carrier Bridge is
 * still being confirmed with sales), so the screens read it from here. The
 * pure navigation maps (MenuData, AdminSections, getPageTitle, EmptyItems)
 * keep a literal next to their siblings and are listed in the rename checklist
 * of CTX-727.
 */
export const CARRIER_BRIDGE_LABEL = "Carrier Bridge";
